var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"btn btn-outline-dark btn-sm",on:{"click":_vm.hideQuestionImage}},[_c('span',[(_vm.slideActive.showQuestionImage)?_c('span',[_vm._v("Hide ")]):_c('span',[_vm._v("Show ")]),_vm._v("\n      image\n    ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }